import * as fromApp from './ui.reducer';

export const reducers = {
  UI: fromApp.reducer
};
